module.exports = __webpack_public_path__ + "img/常用材料和构建自重表@3x.png";